import { useState } from 'react';
import { Heart, Copy, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

const Donate = () => {
  const [copied, setCopied] = useState(false);
  const lightningAddress = 'donate@bitcoinatlas.com';

  const handleCopy = () => {
    navigator.clipboard.writeText(lightningAddress);
    setCopied(true);
    toast.success('Endereço copiado!');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen py-16" data-testid="donate-page">
      <div className="max-w-3xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-12">
          <div className="flex justify-center mb-4">
            <Heart className="text-primary" size={64} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">
            Apoie o Bitcoin Atlas
          </h1>
          <p className="text-lg text-muted-foreground">
            Ajude-nos a continuar produzindo conteúdo educacional sobre Bitcoin de forma independente
          </p>
        </div>

        <div className="bg-card border border-border rounded-sm p-8 mb-8">
          <h2 className="text-2xl font-bold mb-4">Por que doar?</h2>
          <ul className="space-y-3 text-muted-foreground">
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>Mantemos o site livre de anúncios intrusivos</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>Todo conteúdo é gratuito e acessível para todos</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>Promovemos educação sobre autocustódia e soberania financeira</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-primary mt-1">•</span>
              <span>Somos independentes de governos e instituições financeiras</span>
            </li>
          </ul>
        </div>

        <div className="bg-primary/10 border-2 border-primary rounded-sm p-8">
          <h3 className="text-2xl font-bold mb-6 text-center">Doe via Lightning Network</h3>
          
          <div className="bg-white p-8 rounded-sm mb-6 flex justify-center">
            <div className="w-64 h-64 bg-muted rounded-sm flex items-center justify-center">
              <span className="text-muted-foreground text-center px-4">
                QR Code Lightning<br/>
                <span className="text-xs">(Espaço para QR Code)</span>
              </span>
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-2">Endereço Lightning:</label>
            <div className="flex gap-2">
              <input
                type="text"
                value={lightningAddress}
                readOnly
                className="flex-1 px-4 py-3 bg-background border border-border rounded-sm font-mono text-sm"
                data-testid="lightning-address"
              />
              <Button
                onClick={handleCopy}
                variant="secondary"
                className="px-6"
                data-testid="copy-address-button"
              >
                {copied ? <Check size={20} /> : <Copy size={20} />}
              </Button>
            </div>
          </div>

          <p className="text-center text-muted-foreground text-sm">
            Suporte educação Bitcoin independente via Lightning Network
          </p>
        </div>

        <div className="mt-12 text-center text-muted-foreground">
          <p>Não tem uma carteira Lightning?</p>
          <a href="/tutoriais" className="text-primary hover:underline font-medium">
            Aprenda como configurar uma →
          </a>
        </div>
      </div>
    </div>
  );
};

export default Donate;